/**
 * Format attendance check-in/out values from the API.
 * Backend stores LocalTime as "HH:mm:ss" (not ISO datetimes).
 */
export function formatAttendanceTime(
  value: string | null | undefined,
  empty = "--"
): string {
  if (value == null) return empty;
  const raw = String(value).trim();
  if (!raw) return empty;

  const timeOnly = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(raw);
  if (timeOnly) {
    let hours = Number(timeOnly[1]);
    const minutes = timeOnly[2];
    if (!Number.isFinite(hours) || hours < 0 || hours > 23) return raw;
    const ampm = hours >= 12 ? "PM" : "AM";
    const h12 = hours % 12 || 12;
    return `${String(h12).padStart(2, "0")}:${minutes} ${ampm}`;
  }

  // ISO datetime or date+time
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  return raw;
}

/** Parse yyyy-MM-dd (or ISO) as a local calendar date. */
export function formatAttendanceDate(
  value: string | null | undefined,
  empty = "--"
): string {
  if (value == null) return empty;
  const raw = String(value).trim();
  if (!raw) return empty;

  const ymd = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (ymd) {
    const d = new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
    if (!Number.isNaN(d.getTime())) {
      return `${String(d.getDate()).padStart(2, "0")} ${d.toLocaleString("default", {
        month: "short",
      })}, ${d.getFullYear()}`;
    }
  }

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return `${String(parsed.getDate()).padStart(2, "0")} ${parsed.toLocaleString("default", {
      month: "short",
    })}, ${parsed.getFullYear()}`;
  }

  return raw;
}
